import { func, object } from 'prop-types';
import { StandardButton } from '@eika/button';
import React, { useCallback } from 'react';
import Skatterelasjon from './skatterelasjon';
import { emptyList } from '../../../constants';
import { getTaxRelationErrors } from './validation';

const RrMultipleRelations = ({
    question,
    countryContext,
    ekstratekster,
    addSkatterelasjon,
    skatterelasjonLandOptions,
    showErrors,
    onChange,
    getLabel,
}) => {
    const makeRemoveSkatterelasjon = useCallback(
        (relasjonId) => () => {
            onChange({ skatterelasjoner: [...question.skatterelasjoner.filter((el) => el.relasjonId !== relasjonId)] });
        },
        [onChange, question.skatterelasjoner]
    );

    const makeHandleChange = useCallback(
        (id, idKey, valKey) =>
            (key, dataKey = 'value') =>
            (event) => {
                let newVal = event?.target?.[dataKey] ?? event;
                if (event?.target?.type === 'number') {
                    newVal = parseFloat(`${newVal}`.replace(',', '.'));
                }
                // support boolean values in radios
                if (dataKey === 'checked') {
                    newVal = event?.target?.value !== 'false';
                }
                const patched = question[valKey].map((entry) =>
                    entry[idKey] === id
                        ? {
                              ...entry,
                              [key]: newVal,
                          }
                        : entry
                );
                onChange({ [valKey]: patched });
            },
        [onChange, question]
    );

    const removeValue = useCallback(
        (id, idKey, valKey) => (key) => () => {
            // support boolean values in radios
            const patched = question[valKey].map((entry) =>
                entry[idKey] === id
                    ? {
                          ...entry,
                          [key]: undefined,
                      }
                    : entry
            );
            onChange({ [valKey]: patched });
        },
        [onChange, question]
    );

    return (
        <>
            {question.skatterelasjoner.map((relasjon, i) => (
                <Skatterelasjon
                    key={relasjon.relasjonId}
                    relasjon={relasjon}
                    index={i}
                    handleFieldChange={makeHandleChange(relasjon.relasjonId, 'relasjonId', 'skatterelasjoner')}
                    removeself={makeRemoveSkatterelasjon(relasjon.relasjonId)}
                    skatterelasjonLandOptions={skatterelasjonLandOptions}
                    relasjonErrors={
                        showErrors
                            ? getTaxRelationErrors(
                                  relasjon,
                                  question.config,
                                  countryContext.getNorwegianPostalCodesOptions
                              )
                            : emptyList
                    }
                    ekstratekster={ekstratekster}
                    removeValue={removeValue}
                />
            ))}
            <StandardButton id="rr-add-skatterelasjon" onClick={addSkatterelasjon}>
                <i className="ikon-pluss-24" />
                {getLabel(ekstratekster, 'rr_crsflere')}
            </StandardButton>
        </>
    );
};

RrMultipleRelations.propTypes = {
    question: object.isRequired,
    countryContext: object.isRequired,
    ekstratekster: object.isRequired,
    addSkatterelasjon: func.isRequired,
    skatterelasjonLandOptions: object.isRequired,
    showErrors: func.isRequired,
    onChange: func.isRequired,
    getLabel: func.isRequired,
};

export default React.memo(RrMultipleRelations);
